<script setup lang="ts">
import { ref, toRef } from 'vue';
import { CheckIcon } from "@heroicons/vue/24/solid";
import AlertModal from '@/components/ui/modals/AlertModal.vue';
import BoxFileUploader from '@/components/Box/BoxFileUploader.vue';
import BoxContentExplorer from '@/components/Box/BoxContentExplorer.vue';
const props = defineProps<{ createClaimResponse: any}>()
const open = ref(true);
</script>
<template>

<div class="px-10">
  <div class="flex items-center justify-center flex-shrink-0 w-12 h-12 mx-auto mb-4 text-center bg-green-100 rounded-full sm:h-10 sm:w-10">
    <CheckIcon class="w-6 h-6 text-green-600" aria-hidden="true" />
  </div>
  <div 
    class="text-base leading-7"
  >
    <p class="mb-3 text-xl font-semibold text-slate-900">Dossier créé avec succès</p>
    <p>Vous serez notifié une fois étudié par notre équipe juridique.</p>
    <span class="block" v-if="createClaimResponse.claim.legalSpecification?.ec261CompensationAmount">
      Au vu des informations communiquées, chaque passager pourrait être indemnisé à hauteur de
      <span class="font-semibold">{{ createClaimResponse.claim.legalSpecification.ec261CompensationAmount }} euros (€)</span>.
    </span>
  </div>
  
  <div class="mt-10">
    <div class="py-2">
      <p class="text-base leading-7">Merci de nous transmettre dès maintenant les <b>E-Tickets</b> et <b>Cartes d'identités</b>.</p>
      <p class="text-base leading-7">Vous pouvez également apporter tout autre document qui vous semblera utile au dossier.</p>
    </div>
    <div class="max-w-2xl mx-auto mt-8">
      <BoxFileUploader :folderId="createClaimResponse.claim.boxFolderId" :accessToken="createClaimResponse.boxToken.accessToken" />
    </div>
  </div>
</div>
</template>